module.exports = __webpack_public_path__ + "static/media/yo.22bcbce1.png";